import React, { useState } from 'react';

const SignUpPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showSignUpPopup, setShowSignUpPopup] = useState<boolean>(false);

    const signUpToggleHandler = () => {
      setShowSignUpPopup((prev) => !prev);
    };

    return (
      <Component
        showSignUpPopup={showSignUpPopup}
        signUpToggleHandler={signUpToggleHandler}
        {...props}
      />
    );
  };

export default SignUpPopupHOC;